var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCastle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "castle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transaction-Pop-Income",
    transform: "translate(-47.000000, -441.000000)",
    fill: "#E83187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(26.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "castle",
    transform: "translate(21.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "12.9545455 4.66666667 10.2272727 4.66666667 10.2272727 6 8.86363636 6 8.86363636 4.66666667 6.13636364 4.66666667 6.13636364 6 4.77272727 6 4.77272727 4.66666667 2.04545455 4.66666667 2.04545455 12 12.9545455 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "12.2727273 9.33333333 12.2727273 10.6666667 10.9090909 10.6666667 10.9090909 9.33333333 8.18181818 9.33333333 8.18181818 10.6666667 6.81818182 10.6666667 6.81818182 9.33333333 4.09090909 9.33333333 4.09090909 10.6666667 2.72727273 10.6666667 2.72727273 9.33333333 0 9.33333333 0 16 15 16 15 9.33333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.18181818 4.66666667 8.18181818 3.33333333 10.9090909 2 6.81818182 0 6.81818182 4.66666667"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastle);
export default __webpack_public_path__ + "static/media/castle.0f92eab1b7f8be454b73040e0e331d54.svg";
export { ForwardRef as ReactComponent };